
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 18v-2H2v2h16z","fill":"#593289","stroke":"#593289","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M8 3a1 1 0 011-1h2a1 1 0 011 1v6.5a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5V3z","fill":"#593289"}}),_c('path',{attrs:{"d":"M10.378 13.564a.5.5 0 01-.756 0L5.091 8.33A.2.2 0 015.24 8h9.517a.2.2 0 01.152.33l-4.532 5.234z","fill":"#593289"}})])
          )
        }
      }
    